export default "__VITE_ASSET__At_7AUJz__"